export const getters = {
  getModalViewInvestment: state => state.modalViewInvestment,
  getInvestments: state => state.investments,
  getInvestment: state => state.investment
};

export default {};
